import { render } from "./EditAddressInputsSection.vue?vue&type=template&id=63d7d476&scoped=true"
import script from "./EditAddressInputsSection.vue?vue&type=script&lang=js"
export * from "./EditAddressInputsSection.vue?vue&type=script&lang=js"

import "./EditAddressInputsSection.vue?vue&type=style&index=0&id=63d7d476&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d7d476"]])

export default __exports__